import { initFancybox } from "../../../../../growtype/resources/scripts/plugins/fancybox/initFancybox";
import { loadMorePosts } from "../../../../../../plugins/growtype-post/resources/scripts/actions/loadMorePosts";
import {
    growtypePostGetTermsFilterSelectedValues
} from "../../../../../../plugins/growtype-post/resources/scripts/actions/getTermsFilterSelectedValues";
import { addToFavourites } from "../../actions/addToFavourites";

function growtypePost() {
    initRecommendationTracking(document);
    shufflePosts($('.growtype-post-filters-wrapper .btn-shuffle'));

    $('.btn-addtofavourites').each(function (index, element) {
        addToFavourites($(this));
        $(this).addClass('btn-addtofavourites-initialized');
    });

    $(document).on('click', '.btn-info-profile', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const href = $(this).data('href');
        if (href) {
            window.location.href = href;
        }
    });


    /**
     * Load content growtype posts
     */
    ['growtypePostAjaxLoadContent', 'growtypePostAjaxLoadMoreContent'].forEach(element => {
        document.addEventListener(element, function (event) {
            let wrapper = event.detail['wrapper'];

            if (!wrapper) {
                return;
            }

            const addEventHandlers = function (content) {
                $(content).find('.btn-addtofavourites').not('.btn-addtofavourites-initialized').each(function (index, element) {
                    addToFavourites($(this));
                    $(this).addClass('btn-addtofavourites-initialized');
                });

                $(content).find('.avatar-image.growtype-theme-fancybox').not('.avatar-image-initialized').each(function () {
                    initFancybox($(this));
                    $(this).addClass('avatar-image-initialized');
                });
            };

            addEventHandlers(wrapper);
            initRecommendationTracking(wrapper);

            $(wrapper).find('.btn-addtofavourites:not(.btn-addtofavourites-initialized)').each(function () {
                addToFavourites($(this));
                $(this).addClass('btn-addtofavourites-initialized');
            });

            $(wrapper).find('.avatar-image.growtype-theme-fancybox:not(.avatar-image-initialized)').each(function () {
                initFancybox($(this));
                $(this).addClass('avatar-image-initialized');
            });
        });
    });

    ['growtypePostAjaxLoadContent'].forEach(element => {
        document.addEventListener(element, function (event) {
            let wrapper = event.detail['wrapper'];
            shufflePosts($(wrapper).find('.growtype-post-filters-wrapper .btn-shuffle'));
        });
    });

    /**
     * Lazy-load card videos: only fetch/play on hover, release on mouse-out.
     * Skipped entirely on touch/non-hover devices.
     */
    const supportsHover = window.matchMedia('(hover: hover)').matches;

    function initCardVideoHover(context) {
        if (!supportsHover) return;

        $(context).find('.growtype-post-single-inner').each(function () {
            const inner = this;
            if (inner._videoHoverInitialized) return;
            inner._videoHoverInitialized = true;

            // Cache the video reference once — avoids querySelector on every event
            const video = inner.querySelector('.b-content video[data-src]');
            if (!video) return;

            inner.addEventListener('mouseenter', function () {
                // Set src only once — subsequent hovers reuse the buffered video
                if (!video.src || video.src === window.location.href) {
                    video.src = video.dataset.src;
                }
                video.play().catch(() => { });
            });

            inner.addEventListener('mouseleave', function () {
                video.pause();
                // Keep src intact so the browser doesn't re-fetch on next hover
            });
        });
    }

    // Init on page load — guard against deferred scripts where DOMContentLoaded
    // may have already fired before this listener is registered.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initCardVideoHover(document);
        });
    } else {
        initCardVideoHover(document);
    }

    // Re-init after AJAX loads new cards
    ['growtypePostAjaxLoadContent', 'growtypePostAjaxLoadMoreContent'].forEach(element => {
        document.addEventListener(element, function (event) {
            const wrapper = event.detail['wrapper'];
            if (wrapper) initCardVideoHover(wrapper);
        });
    });

    function shufflePosts(trigger) {
        /**
         * Shuffle
         */
        trigger.click(function (event) {
            event.preventDefault();

            let btn = $(this);

            if (btn.find('svg').hasClass('anim-spin')) {
                return;
            }

            btn.find('svg').addClass('anim-spin');

            let postsWrapper = btn.closest('.growtype-post-container-wrapper');
            let args = postsWrapper.attr('data-args');
            let filtersContainer = postsWrapper.find('.growtype-post-terms-filters');
            let filterParams = growtypePostGetTermsFilterSelectedValues(filtersContainer);
            args = args ? JSON.parse(args) : {};
            args['shuffle'] = true;
            args['selected_terms_navigation_values'] = Object.assign({}, filterParams);
            let elements = {};
            elements['posts_container'] = postsWrapper.find('.growtype-post-container');

            loadMorePosts(elements, args)
                .then(function (response) {
                    btn.find('svg').removeClass('anim-spin');
                }, function () {
                    btn.find('svg').removeClass('anim-spin');
                })
        });
    }
}

let recommendationObserver = null;

function getRecommendationDetails(card) {
    const wrapper = card.closest('.growtype-post-container-wrapper');
    if (!wrapper || card.classList.contains('growtype-post-roleplay')) return null;

    let args = {};
    try {
        args = JSON.parse(wrapper.getAttribute('data-args') || '{}');
    } catch (error) {
        args = {};
    }

    const cards = Array.from(wrapper.querySelectorAll('.growtype-post-single:not(.growtype-post-roleplay)'));
    const favouriteButton = card.querySelector('[data-slug]');
    const identityElement = card.hasAttribute('data-id') ? card : card.querySelector('[data-id]');
    const link = card.matches('a[href]') ? card : card.querySelector('a[href]');
    let characterSlug = favouriteButton ? favouriteButton.getAttribute('data-slug') : '';
    if (!characterSlug && link) {
        try {
            const segments = new URL(link.href, window.location.origin).pathname.split('/').filter(Boolean);
            characterSlug = (segments.pop() || '').split('::')[0];
        } catch (error) {
            characterSlug = '';
        }
    }

    if (!characterSlug) return null;

    const contentSource = wrapper.getAttribute('data-content-source') || 'growtype_post';
    return {
        recommendation_rule: args.recommendation_rule || args.orderby || contentSource,
        recommendation_rule_version: args.recommendation_rule_version || 'v1',
        recommendation_source: args.recommendation_source || wrapper.id || contentSource,
        recommendation_position: Math.max(1, cards.indexOf(card) + 1),
        recommended_character_id: identityElement ? (identityElement.getAttribute('data-id') || '') : '',
        recommended_character_slug: characterSlug,
    };
}

function trackRecommendation(eventType, card) {
    if (typeof window.gaTrack !== 'function') return;
    const details = getRecommendationDetails(card);
    if (!details) return;

    window.gaTrack(eventType, {
        object_id: details.recommended_character_id || details.recommended_character_slug,
        object_type: 'character',
        metadata: details,
    });

    if (eventType === 'recommendation_click') {
        const expires = new Date(Date.now() + (30 * 86400000)).toUTCString();
        document.cookie = 'ga_attribution_context=' + encodeURIComponent(JSON.stringify(details))
            + '; path=/; expires=' + expires + '; SameSite=Lax';
    }
}

function initRecommendationTracking(context) {
    if (!recommendationObserver && 'IntersectionObserver' in window) {
        recommendationObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
                const card = entry.target;
                recommendationObserver.unobserve(card);
                trackRecommendation('recommendation_impression', card);
            });
        }, {threshold: [0.5]});
    }

    $(context).find('.growtype-post-container-wrapper .growtype-post-single').each(function () {
        if (this.dataset.recommendationTrackingInitialized === '1') return;
        if (!getRecommendationDetails(this)) return;
        this.dataset.recommendationTrackingInitialized = '1';
        if (recommendationObserver) {
            recommendationObserver.observe(this);
        } else {
            trackRecommendation('recommendation_impression', this);
        }
    });
}

$(document).on('click', '.growtype-post-container-wrapper .growtype-post-single', function (event) {
    if ($(event.target).closest('.btn-addtofavourites, button').length) return;
    trackRecommendation('recommendation_click', this);
});

export { growtypePost };
